import { ChevronIcon } from "../../../materials/icons/chevron-icon/ChevronIcon";
import { DismissIcon } from "../../../materials/icons/dismiss-icon/DismissIcon";
import { Body } from "../../body/Body";
import { IconButton } from "../../icon-button/IconButton.Parts";
import { Action, Props, Title, TitleGroup, Wrapper } from "./Head.Parts";

export const Head = ({
  Back,
  Close,
  title,
  subtitle,
  hasHandle,
  hasDivider,
  onBack,
  onClose,
}: Props) => {
  return (
    <Wrapper
      $hasHandle={hasHandle}
      $hasDivider={hasDivider}
      $hasAction={Boolean(Back || Close || onBack || onClose)}
    >
      <Action>
        {Back && !onBack && Back}

        {!Back && onBack && (
          <IconButton onClick={onBack}>
            <ChevronIcon orientation="left" width="1rem" height=".625rem" />
          </IconButton>
        )}
      </Action>

      <Title>
        <TitleGroup>
          <Body variant="normal-strong">{title}</Body>
          {subtitle && (
            <Body variant="small" color="shade300">
              {subtitle}
            </Body>
          )}
        </TitleGroup>
      </Title>

      <Action>
        {Close && !onClose && Close}

        {!Close && onClose && (
          <IconButton onClick={onClose}>
            <DismissIcon />
          </IconButton>
        )}
      </Action>
    </Wrapper>
  );
};
